import { useQuery } from "@tanstack/react-query";
import { getRevenueMachineRenderMonthApi } from "../../services/revenue/get.revenue.machine.render.month.api";

export const useGetRevenueMachineRenderMothApi = ({ monthSelect, storeCode }: { monthSelect?: any, storeCode: any }) => {
  // const { storeId } = useRevenueMachine();

  const { data, isLoading } = useQuery({
    queryKey: ["revenue-machine-render-month", monthSelect, storeCode],
    queryFn: () => getRevenueMachineRenderMonthApi(storeCode, monthSelect),
    enabled: !!monthSelect && !!storeCode,
  });
  return {
    revenueMachineRenderMonth: data,
    isLoading,
  };
};
